import type { ClientResource } from '@/features/Clients';
import { mapToApiClient } from '@/features/Clients/ClientMapper/clientMapper';
import type {
  MAIL_TEMPLATE_NAME,
  MailPlaceholder,
  MailTemplate,
} from '@/features/MailTemplate/types';
import type { HttpClientResponse } from '@/services/api/HttpClient';
import { HttpService } from '@/services/api/HttpService';

export class MailTemplateHttpService extends HttpService {
  loadTemplates(): HttpClientResponse<MailTemplate[]> {
    return this.httpClient.get('mail-templates');
  }

  loadDefaultTemplateByName(
    templateName: MAIL_TEMPLATE_NAME,
  ): HttpClientResponse<MailTemplate> {
    return this.httpClient.get(`mail-templates/default/${templateName}`);
  }

  loadPlaceholders(): HttpClientResponse<MailPlaceholder[]> {
    return this.httpClient.get('mail-templates/placeholders');
  }

  generatePreview(
    template: MailTemplate,
    client?: ClientResource,
  ): HttpClientResponse<MailTemplate> {
    return this.httpClient.post('mail-templates/preview', {
      data: {
        ...template,
        preview: {
          kunde: client === undefined ? undefined : mapToApiClient(client),
        },
      },
    });
  }

  storeTemplate(template: MailTemplate): HttpClientResponse<MailTemplate> {
    return this.httpClient.post('mail-templates', {
      data: template,
    });
  }

  updateTemplate(template: MailTemplate): HttpClientResponse<MailTemplate> {
    return this.httpClient.put(`mail-templates/${template.id}`, {
      data: template,
    });
  }

  deleteTemplate(template: MailTemplate): HttpClientResponse<void> {
    return this.httpClient.delete(`mail-templates/${template.id}`);
  }
}
